export default __webpack_public_path__ + "static/article-time-to-call-a-builder-4f925a0f594c2c294e66adecd48833f6.jpg";